import { type Common } from './common.js';
import {
  type NoticeOfAdmission,
  type NoticeOfAdmissionStatus,
  type UpsertStatus,
} from './models/noticeOfAdmission.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findOne(encounterId: string): Promise<NoticeOfAdmission> {
    const url = this.common.constructPath(`/notice-of-admission`, {
      encounterId,
    });
    return await this.common.getJSON(url);
  }

  async upsert(encounterId: string, context: NoticeOfAdmission): Promise<NoticeOfAdmission> {
    const url = this.common.constructPath(`/notice-of-admission`);
    return await this.common.putJSON(url, { encounterId, context });
  }

  async getStatus(encounterId: string): Promise<NoticeOfAdmissionStatus | undefined> {
    const url = this.common.constructPath(`/notice-of-admission/status`, {
      encounterId,
    });
    return await this.common.getJSON(url);
  }

  async upsertStatus(args: UpsertStatus): Promise<NoticeOfAdmissionStatus | undefined> {
    const url = this.common.constructPath(`/notice-of-admission/status`);
    return await this.common.putJSON(url, args);
  }

  async startExport(encounterId: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`/notice-of-admission/export`);
    return await this.common.postJSON(url, {
      encounterId,
      workflowHandling: 'REQUIRE',
    });
  }

  async startExtract(encounterId: string): Promise<{ success: true }> {
    const url = this.common.constructPath('/notice-of-admission/extract');
    return await this.common.postJSON(url, {
      encounterId,
      workflowHandling: 'REQUIRE',
    });
  }
}
